// TOUR-26 — Platform home safety chrome (context card + impersonation).

import type { FireflyTourArtifact } from "../tourTypes";

export const PLATFORM_HOME_TOUR_ID = "tour-platform-home";

const PLATFORM_ROLES = [
  "platform_owner",
  "platform_admin",
  "platform_dev",
  "platform_trainer",
] as const;

export const PLATFORM_HOME_TOUR: FireflyTourArtifact = {
  id: PLATFORM_HOME_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "platform tour",
    "impersonation help",
    "platform home tour",
    "walk me through platform",
    "show me platform context",
    "dev simulator tour",
  ],
  bucketRelevance: ["platform"],
  requiredRoles: [...PLATFORM_ROLES],
  steps: [
    {
      id: "nav-platform",
      target: {
        mode: "platform",
        anchorId: "mode-nav-platform",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "platform",
      copy: {
        title: "Open Platform",
        body: "Cross-org overview and safety chrome live in the Platform bucket. Tap Platform in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "platform-surface",
      target: {
        mode: "platform",
        anchorId: "platform-surface",
        scrollIntoView: true,
      },
      copy: {
        title: "Platform View",
        body: "Overview counts, Organizations, and Users are support tools — not a sales desk. Your real platform role still gates RPCs even when impersonation changes the UI.",
      },
      advanceOn: "next_button",
    },
    {
      id: "activity-dock",
      target: {
        mode: "platform",
        anchorId: "activity-dock-tab",
        scrollIntoView: true,
      },
      copy: {
        title: "Open Activity / Firefly",
        body: "Platform context lives in the Activity dock when you are in the Platform bucket. Tap the Firefly tab to expand it.",
      },
      waitForClick: true,
    },
    {
      id: "platform-context",
      target: {
        mode: "platform",
        anchorId: "platform-context",
        scrollIntoView: true,
      },
      copy: {
        title: "Platform context card",
        body: "Confirm your resolved platform role, scoped org, and any active impersonation mask. Use Open Platform home to jump back here anytime.",
      },
      advanceOn: "next_button",
    },
    {
      id: "dev-simulator",
      target: {
        mode: "platform",
        anchorId: "dev-simulator",
        scrollIntoView: true,
      },
      copy: {
        title: "Dev simulator",
        body: "Sidebar Dev simulator (platform_dev) sets browser-only role + viewport axes. Apply impersonation yourself — the tour will not flip roles. JWT/RLS still use your real identity.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "platform", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Bug triage and the Dev sync queue live under Platform → Dev. Ask Firefly anytime for admin org or manufacturing tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
